import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export class ObjectNummerWijzigData {
  objectnummer: number;
  volgnummer:number;
}


@Component({
  selector: 'app-change-number',
  templateUrl: './change-number.component.html',
  styleUrls: ['./change-number.component.less']
})
export class ChangeNumberComponent implements OnInit {


  // public data = new ObjectNummerWijzigData();

  constructor(
    public dialogRef: MatDialogRef<ObjectNummerWijzigData>,
    @Inject(MAT_DIALOG_DATA) public data:ObjectNummerWijzigData
  ) { }

  ngOnInit(): void {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
